import axios from "axios";

const BASE_URL = "https://backdanlu.eu-4.evennode.com";

// ✅ GET: Traer todos los gastos
export const getGastos = async () => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/gastos`;

  try {
    const resp = await axios.get(url, { headers: { token } });
    return resp.data;
  } catch (error) {
    console.log("❌ BACKEND ERROR GET /gastos:", error.response?.data);
    return {
      ok: false,
      error: error.response?.data || "Error al obtener gastos",
    };
  }
};

// ✅ GET: Traer un gasto por ID
export const getGastoById = async (id) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/gastos/${id}`;

  try {
    const resp = await axios.get(url, { headers: { token } });
    return resp.data;
  } catch (error) {
    console.log("❌ BACKEND ERROR GET /gastos/:id:", error.response?.data);
    return {
      ok: false,
      error: error.response?.data || "Error al obtener gasto",
    };
  }
};

// ✅ POST: Crear nuevo gasto
export const postGasto = async (gastoData) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/gastos`;

  try {
    const resp = await axios.post(url, gastoData, {
      headers: { "Content-Type": "application/json", token },
    });
    return resp.data;
  } catch (error) {
    console.log("❌ BACKEND ERROR POST /gastos:", error.response?.data);
    console.log("❌ STATUS:", error.response?.status);
    console.log("❌ MSG:", error.message);

    return {
      ok: false,
      error: error.response?.data || "Error al crear gasto",
    };
  }
};

// ✅ PUT: Actualizar gasto
export const putGasto = async (id, gastoData) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/gastos/${id}`;

  try {
    const resp = await axios.put(url, gastoData, {
      headers: { "Content-Type": "application/json", token },
    });
    return resp.data;
  } catch (error) {
    console.log("❌ BACKEND ERROR PUT /gastos:", error.response?.data);
    return {
      ok: false,
      error: error.response?.data || "Error al actualizar gasto",
    };
  }
};

// ✅ DELETE: Desactivar gasto
export const deleteGasto = async (id) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/gastos/${id}`;

  try {
    const resp = await axios.delete(url, { headers: { token } });
    return resp.data;
  } catch (error) {
    console.log("❌ BACKEND ERROR DELETE /gastos:", error.response?.data);
    return {
      ok: false,
      error: error.response?.data || "Error al eliminar gasto",
    };
  }
};